import HistoryDetails from "@/shared/model/HistoryDetails";

export default class HistoryDetailsIdString extends HistoryDetails {
  id?: string
  idType?: string
  value?: string
}
